import { ReactNode } from 'react';
import { useDialogStore } from './dialog-store';
import { DialogFlag, DialogId, DialogOptions } from './helpers';

const show = <T>(options: DialogOptions<T>, children?: ReactNode) => {
  const store = useDialogStore.getState();
  return store.show<T>(options, children);
};
const confirm = <T>(options: DialogOptions<T>, children?: ReactNode) =>
  show({ flags: DialogFlag.OK | DialogFlag.CANCEL, ...options }, children);

export const dialog = Object.assign(
  show,
  {
    /**
     * 显示对话框 - 统一的入口方法
     */
    show,
    /**
     * 显示确认对话框
     */
    confirm,
    requestClose: (dialogId: DialogId, flag?: DialogFlag) => {
      const store = useDialogStore.getState();
      return store.requestClose(dialogId, flag);
    },
    close: (
      dialogId: DialogId,
      flag: DialogFlag = DialogFlag.CLOSE,
      returnValue?: unknown
    ) => {
      const store = useDialogStore.getState();
      return store.close(dialogId, flag, returnValue);
    },
  },
  DialogFlag
);
